<div class="modal-dark">
  <div class="modal-header">
    <h4 class="modal-title">Why are you cancelling your plan?</h4>
  </div>
  <div class="modal-body">
    @for (reason of subscriptionReasons; track reason) {
    <div class="form-check input-radio-select">
      <input
        class="form-check-input"
        type="radio"
        (change)="onReasonSelect(reason.id)"
        name="cancelReasonRadio"
        id="cancelReason{{ reason.id }}" />
      <label
        class="form-check-label"
        [ngClass]="{ 'border-secondary': selectedReason === reason.id }"
        for="cancelReason{{ reason.id }}">
        {{ reason.reason }}
      </label>
    </div>
    }
  </div>

  <div class="modal-footer">
    <button
      class="btn btn-light"
      (click)="onCancel()">
      Keep subscription
    </button>
    <button
      [disabled]="!selectedReason"
      class="btn btn-primary"
      type="submit"
      (click)="onAccept()">
      Cancel subscription
    </button>
  </div>
</div>
